// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_n4-0";